import { AppProductTypeEnum } from 'src/graphql/schema';

const escrowBaseUrls: Partial<Record<AppProductTypeEnum, string>> = {
  [AppProductTypeEnum.SaasEscrow]: '/saas-escrows',
  [AppProductTypeEnum.SoftwareEscrow]: '/software-escrows',
  [AppProductTypeEnum.ContinuityEscrow]: '/continuity-escrows',
};

type IEscrowRef = {
  id: string;
  productType: AppProductTypeEnum;
};

export const getEscrowUrl = ({ id, productType }: IEscrowRef) => {
  const baseUrl = escrowBaseUrls[productType];

  return baseUrl ? `${baseUrl}/${id}` : '/';
};
